export default function PHP_ftp_set_option() {
  return (
    <div>
      <h1>PHP_ftp_set_option</h1>
    </div>
  );
}
